import _ReactGA from "react-ga4";
const ReactGA = _ReactGA.default;
import { LEGACY_GA_TRACKING_ID } from "../../utils/gvSecrets";
import { getIsLocalhost } from "../../utils/isLocalHost";
import useGaTracking from "../../hooks/useGaTracking";

const GoogleAnalytics = () => {
  ReactGA.initialize(LEGACY_GA_TRACKING_ID, {
    gaOptions: {
      debug_mode: getIsLocalhost(),
    },
    gtagOptions: {
      debug_mode: getIsLocalhost(),
    },
  });

  useGaTracking();

  return null;
};

export default GoogleAnalytics;
